import { arrayMove } from "@dnd-kit/sortable";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";
import { Collection, CollectionStyle } from "@is/types";

const TOTAL_VERTICAL_PADDINGS_FOR_CONTAINER = 76;
const HEIGHT_OF_COLLECTION_ITEM = 80;

const useManageCollectionList = (
  collection: Collection,
  onReorder: (items: CollectionStyle[]) => void
) => {
  const { t } = useTranslation(TranslationContext.Settings);
  const [collectionItems, setCollectionItems] = useState(collection.items);

  const handleDragEnd = useCallback(
    (event: any) => {
      const { active, over } = event;
      if (active.id !== over.id) {
        let reorderedList = collectionItems;

        setCollectionItems((prev) => {
          const activeIndex = collectionItems.findIndex(
            (item) => item.variantId === active.id
          );
          const overIndex = collectionItems.findIndex(
            (item) => item.variantId === over.id
          );
          reorderedList = arrayMove(prev, activeIndex, overIndex);

          return reorderedList;
        });

        onReorder(reorderedList);
      }
    },
    [collectionItems, onReorder]
  );

  useEffect(() => {
    setCollectionItems(collection.items);
  }, [collection]);

  return {
    t,
    collectionItems,
    containerHeight:
      TOTAL_VERTICAL_PADDINGS_FOR_CONTAINER +
      collectionItems.length * HEIGHT_OF_COLLECTION_ITEM,
    handleDragEnd,
  };
};

export default useManageCollectionList;
